export type ProductGroupCreateDTO = {
  groupName: string;
  groupType: ProductGroupType;
  description: string;
  adFormat?: string;
  channel?: string;
  channelGroupId?: number;
  groupValues: {
    limitationName: string;
    limitationValue: string;
  }[];
  customGroupValues: {
    limitationName: string;
    limitationValue: string;
  }[];
  agencyIds: number[];
  attributes?: { [key: string]: string[] };
  autoUpdate: boolean;
};

export type ProductGroupUpdateDTO = {
  id: number;
} & ProductGroupCreateDTO;

export type ProductGroupReadDTO = Omit<
  ProductGroupUpdateDTO,
  'groupValues' | 'customGroupValues'
> & {
  state: number;
  groupValues: SelectOptions[];
  customGroupValues: SelectOptions[];
};

export type ProductGroupListDTO = Pick<
  ProductGroupReadDTO,
  'id' | 'groupName' | 'groupType' | 'description' | 'state' | 'autoUpdate'
> & {
  agencys: string[];
};

type BaseProductGroupFormValue = {
  groupName: string;
  description: string;
  groupValues: SelectOptions[];
  customGroupValues: SelectOptions[];
  agencyIds: number[];
};
export type DomainProductGroupFormValue = BaseProductGroupFormValue & {
  groupType: ProductGroupType.DOMAIN;
  attributes?: never;
};
export type SpaceProductGroupFormValue = BaseProductGroupFormValue & {
  groupType: ProductGroupType.ADSPACE;
  channel: string;
  channelGroupId?: number;
  adFormat: string;
  attributes: { [key: string]: string[] };
};
export type ProductGroupFormValue =
  | DomainProductGroupFormValue
  | SpaceProductGroupFormValue;

export enum ProductGroupType {
  DOMAIN = 'DOMAIN',
  ADSPACE = 'ADSPACE'
}

export const AUTO_UPDATE_VALUE = 'autoUpdate';
export const ALL_SELECT_VALUE = 'all';
